export function registerChannelsSmm() {
    Alpine.data('smmChannelPage', () => ({
        loading: false,
        error: '',
        chats: [],
        plan: null,
        planLoading: false,
        planError: '',
        planSaveMessage: '',
        planPeriodDays: 14,
        editingPlanIndex: null,
        planEditBackup: null,
        checkConnectionMessage: '',
        checkConnectionLoading: false,
        posts: [],
        postsLoading: false,
        postsError: '',
        schedulingPostId: null,
        scheduleDate: '',
        minScheduleDate() {
            const d = new Date();
            d.setMinutes(d.getMinutes() + 1);
            return d.toISOString().slice(0, 16);
        },
        formatScheduledAt(iso) {
            if (!iso) return '';
            const d = new Date(iso.replace(' ', 'T'));
            return d.toLocaleString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' });
        },
        formatPubDate(iso) {
            if (!iso) return '—';
            const d = new Date(String(iso).replace(' ', 'T'));
            return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short', year: 'numeric' });
        },
        publishedPostsList() {
            return (this.posts || []).filter(p => p.status === 'published').sort((a, b) => new Date(b.published_at || 0) - new Date(a.published_at || 0)).slice(0, 15);
        },
        bestPublishedPost() {
            const list = this.publishedPostsList();
            if (!list.length) return null;
            return list.reduce((best, p) => {
                const v = (p.meta && p.meta.views != null) ? p.meta.views : 0;
                const bv = (best.meta && best.meta.views != null) ? best.meta.views : 0;
                return v > bv ? p : best;
            });
        },
        openSchedule(postId) {
            this.schedulingPostId = postId;
            const d = new Date();
            d.setDate(d.getDate() + 1);
            d.setHours(10, 0, 0, 0);
            this.scheduleDate = d.toISOString().slice(0, 16);
        },
        submitSchedule(postId) {
            if (!this.scheduleDate) return;
            this.postsError = '';
            fetch('/api/smm/posts/schedule', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken() },
                body: JSON.stringify({ post_id: postId, scheduled_at: this.scheduleDate })
            })
                .then(r => r.json())
                .then(data => { if (data.ok) { this.schedulingPostId = null; this.loadPosts(); } else { this.postsError = data.error || 'Ошибка'; } })
                .catch(e => { this.postsError = 'Ошибка: ' + (e.message || ''); });
        },
        loadPosts() {
            fetch('/api/smm/posts').then(r => r.json()).then(data => { if (data.ok) this.posts = data.posts || []; this.postsError = ''; }).catch(() => { this.posts = []; });
        },
        generatePosts() {
            this.postsLoading = true;
            this.postsError = '';
            fetch('/api/smm/posts/generate', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken() }, body: JSON.stringify({ limit: 5 }) })
                .then(r => r.json())
                .then(data => { this.postsLoading = false; if (data.ok) { this.posts = data.posts || []; this.postsError = ''; } else { this.postsError = data.error || 'Ошибка генерации'; } })
                .catch(e => { this.postsLoading = false; this.postsError = 'Ошибка сети: ' + (e.message || ''); });
        },
        publishPost(postId) {
            this.postsError = '';
            fetch('/api/smm/posts/publish', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken() }, body: JSON.stringify({ post_id: postId }) })
                .then(r => r.json())
                .then(data => { if (data.ok) { this.loadPosts(); } else { this.postsError = data.error || 'Ошибка публикации'; } })
                .catch(e => { this.postsError = 'Ошибка: ' + (e.message || ''); });
        },
        addPlanItem() {
            if (!this.plan || !this.plan.plan_snapshot) return;
            const d = new Date(); d.setDate(d.getDate() + 1);
            this.plan.plan_snapshot.push({ date: d.toISOString().slice(0, 10), theme: '', format: 'post', notes: '' });
            this.savePlanEdit();
        },
        removePlanItem(i) {
            if (!this.plan || !this.plan.plan_snapshot) return;
            if (!confirm('Удалить этот пункт из плана?')) return;
            this.plan.plan_snapshot.splice(i, 1);
            if (this.editingPlanIndex === i) this.editingPlanIndex = null;
            else if (this.editingPlanIndex > i) this.editingPlanIndex--;
            this.savePlanEdit();
        },
        savePlanEdit() {
            if (!this.plan || !this.plan.plan_snapshot) return;
            this.planError = ''; this.planSaveMessage = '';
            fetch('/api/smm/content-plan/update', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken() }, body: JSON.stringify({ plan_snapshot: this.plan.plan_snapshot }) })
                .then(r => r.json())
                .then(data => { if (data.ok) { this.plan = data.plan || this.plan; this.planSaveMessage = 'План сохранён'; setTimeout(() => { this.planSaveMessage = ''; }, 3000); } else { this.planError = data.error || 'Ошибка сохранения'; } })
                .catch(e => { this.planError = 'Ошибка: ' + (e.message || ''); });
        },
        startEditPlanItem(i) {
            if (this.plan && this.plan.plan_snapshot && this.plan.plan_snapshot[i]) { this.planEditBackup = { ...this.plan.plan_snapshot[i] }; }
            this.editingPlanIndex = i;
        },
        cancelPlanEdit(i) {
            if (this.planEditBackup && this.plan && this.plan.plan_snapshot && this.plan.plan_snapshot[i]) { this.plan.plan_snapshot[i] = { ...this.planEditBackup }; }
            this.planEditBackup = null;
        },
        regeneratePlanConfirm() { if (!confirm('Текущий план будет заменён новым. Продолжить?')) return; this.generatePlan(); },
        hasFailedPosts() { return (this.posts || []).some(p => p.status === 'failed'); },
        checkConnection() {
            this.checkConnectionMessage = ''; this.checkConnectionLoading = true;
            fetch('/api/smm/check-connection').then(r => r.json())
                .then(data => { this.checkConnectionLoading = false; this.checkConnectionMessage = data.message || (data.channel_found ? 'Канал в списке.' : 'Канал не найден.'); })
                .catch(() => { this.checkConnectionLoading = false; this.checkConnectionMessage = 'Ошибка запроса'; });
        },
        loadPlan() {
            fetch('/api/smm/content-plan').then(r => r.json()).then(data => { if (data.ok) this.plan = data.plan || null; this.planError = ''; }).catch(() => { this.plan = null; });
        },
        generatePlan() {
            this.planLoading = true; this.planError = '';
            fetch('/api/smm/content-plan/generate', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken() }, body: JSON.stringify({ period_days: parseInt(this.planPeriodDays, 10) || 14 }) })
                .then(r => r.json())
                .then(data => { this.planLoading = false; if (data.ok) { this.plan = data.plan || null; this.planError = ''; } else { this.planError = data.error || data.error_detail || 'Ошибка генерации'; } })
                .catch(e => { this.planLoading = false; this.planError = 'Ошибка сети: ' + (e.message || ''); });
        },
        fetchChats() {
            this.loading = true; this.error = ''; this.chats = [];
            fetch('/api/smm/max-chats').then(r => r.json())
                .then(data => { this.loading = false; if (data.ok && Array.isArray(data.chats)) { this.chats = data.chats; if (this.chats.length === 0) this.error = 'Нет чатов и каналов. Добавьте бота в канал MAX и попробуйте снова.'; } else { this.error = data.error || 'Не удалось загрузить список.'; } })
                .catch(e => { this.loading = false; this.error = 'Ошибка сети: ' + (e.message || 'unknown'); });
        },
        connectChat(chat) {
            this.loading = true; this.error = '';
            fetch('/api/smm/connect', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': window.getCsrfToken() }, body: JSON.stringify({ chat_id: chat.chat_id, title: chat.title || '', link: chat.link || '' }) })
                .then(r => r.json())
                .then(data => { this.loading = false; if (data.ok && data.redirect) { window.location.href = data.redirect; } else { this.error = data.error || 'Ошибка подключения.'; } })
                .catch(e => { this.loading = false; this.error = 'Ошибка: ' + (e.message || 'unknown'); });
        }
    }));
}
